const logoUrl = 'https://ohanyanbrandy.com/images/logo/logo.svg';

export const homeJsonLd = {
	'@context': 'https://schema.org',
	'@type': 'Organization',
	'name': 'Ohanyan Brandy Company',
	'url': '',
	'logo': logoUrl,
	'foundingDate': '1998',
	'founder': {
		'@type': 'Person',
		'name': 'Gevorg Zh. Ohanyan',
	},
	'address': {
		'@type': 'PostalAddress',
		'streetAddress': 'Zakyan St., 5/17 Building',
		'addressLocality': 'Yerevan',
		'postalCode': '0001',
		'addressCountry': 'AM',
	},
	'contactPoint': {
		'@type': 'ContactPoint',
		'telephone': '+374-10-540534',
		'contactType': 'Customer Service',
		'availableLanguage': ['English', 'Armenian', 'Russian'],
	},
	'sameAs': ['https://www.facebook.com/OhanyanBrandyCompany', 'https://www.instagram.com/ohanyan_brandy_company/'],
};

export const blogJsonLd = {
	'@context': 'https://schema.org',
	'@type': 'Blog',
	'publisher': {
		'@type': 'Organization',
		'name': 'Ohanyan',
		'logo': {
			'@type': 'ImageObject',
			'url': logoUrl,
		},
	},
};

export const articleJsonLd = {
	'@context': 'https://schema.org',
	'@type': 'BlogPosting',
	'author': {
		'@type': 'Organization',
		'name': 'Ohanyan',
	},
	'publisher': {
		'@type': 'Organization',
		'name': 'Ohanyan',
		'logo': {
			'@type': 'ImageObject',
			'url': logoUrl,
		},
	},
};

export const productCollectionListJsonLd = {
	'@context': 'https://schema.org',
	'@type': 'ItemList',
};

export const productCollectionJsonLd = {
	'@context': 'https://schema.org',
	'@type': 'CollectionPage',
};

export const productJsonLd = {
	'@context': 'https://schema.org',
	'@type': 'Product',
	'brand': {
		'@type': 'Brand',
		'name': 'Ohanyan',
	},
};
